export const styleSections = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    border: "1px solid #E8DFD5",
    borderRadius: 2
};